var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0539 27.8C15.7201 27.8 13.4387 27.1079 11.4982 25.8113C9.55768 24.5147 8.04525 22.6718 7.15213 20.5156C6.25902 18.3595 6.02534 15.9869 6.48065 13.6979C6.93595 11.4089 8.05979 9.30636 9.71005 7.6561C11.3603 6.00584 13.4629 4.882 15.7518 4.42669C18.0408 3.97139 20.4134 4.20506 22.5696 5.09818C24.7257 5.99129 26.5687 7.50373 27.8653 9.44423C29.1619 11.3847 29.8539 13.6661 29.8539 16C29.8539 19.1295 28.6107 22.1309 26.3978 24.3438C24.1848 26.5567 21.1835 27.8 18.0539 27.8Z",
    stroke: "#03061F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10V16L21 21",
    stroke: "#03061F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.95d697d7e6ea0d0938f53e4a22e29d10.svg";
export { ForwardRef as ReactComponent };